<template>
  <v-select
    :items="paymentTypes"
    v-model="selectedPaymentType"
    item-text="name"
    item-value="name"
    label="Payment Type"
    @change="onChange"
    :outlined="outlined"
    :hide-details="hideDetails"
    :dense="dense"
  ></v-select>
</template>

<script>
import { ALL_PAYMENT_TYPES_SEARCH_QUERY } from "../../../constants/graphql";

export default {
  name: "PaymentTypeSelect",

  props: {
    outlined: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: String,
      default: () => "",
    },
    hideDetails: {
      type: Boolean,
      default: () => false,
    },
    dense: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      paymentTypes: [],
      selectedPaymentType: this.value ? this.value : "",
    };
  },

  methods: {
    onChange(event) {
      this.$emit("input", this.selectedPaymentType);
    },
  },

  watch: {
    value(newVal) {
      this.selectedPaymentType = newVal;
    },
  },

  apollo: {
    paymentTypes: {
      query: ALL_PAYMENT_TYPES_SEARCH_QUERY,
      result({ data, loader, networkStatus }) {
        this.paymentTypes = data.paymentTypes.edges.map((pt) => ({
          ...pt.node,
        }));
      },
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/shared/PaymentTypeSelect.vue